module.exports = __webpack_public_path__ + "img/mistakesText4.eb6c853b.png";